import { bl_applet_to_catalog_link_import_file_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';


export class AppletToCatalogLinkFileHdrContainerModel extends BaseContainerModel {
  bl_applet_to_catalog_link_import_file_hdr: bl_applet_to_catalog_link_import_file_hdr_RowClass = new bl_applet_to_catalog_link_import_file_hdr_RowClass();
}
